<div class="option" (click)="selectAll(node, options, $event)">
  <div class="checkbox" [class.selected]="isSelectAll">
    @if (isSelectAll) {
    <img src=" assets/images/common/tick.svg" />
    }
  </div>
  <div class="option-text">Select All</div>
</div>
